module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseRaccoonDog_f_leucistic.167b778a.png";